import { Theme, css } from 'antd-style';

const antdOverrideStyles = ({ token }: { prefixCls: string; token: Theme }) => css`
  .${token.prefixCls}-popover {
    z-index: 1100;
  }

  .${token.prefixCls}-menu-sub.${token.prefixCls}-menu-vertical {
    border: 1px solid ${token.colorBorder};
    box-shadow: ${token.boxShadow};
  }

  .${token.prefixCls}-menu-item-selected {
    .${token.prefixCls}-menu-title-content {
      color: ${token.colorText};
    }
  }

  /* Dropdown: Use fade animation instead of zoom (200ms) */
  .${token.prefixCls}-dropdown {
    &.${token.prefixCls}-zoom-enter, &.${token.prefixCls}-zoom-appear {
      transform: none !important;
      opacity: 0;
      animation: fadeSlideIn 0.2s ease-out forwards !important;
    }

    &.${token.prefixCls}-zoom-leave {
      animation: fadeSlideOut 0.15s ease-in forwards !important;
    }
  }

  /* Modal: Use fade animation instead of zoom (250ms) */
  .${token.prefixCls}-modal {
    &.${token.prefixCls}-zoom-enter, &.${token.prefixCls}-zoom-appear {
      transform: none !important;
      opacity: 0;
      animation: fadeIn 0.25s ease-out forwards !important;
    }

    &.${token.prefixCls}-zoom-leave {
      animation: fadeOut 0.2s ease-in forwards !important;
    }
  }

  /* Modal mask: fade in/out */
  .${token.prefixCls}-modal-mask {
    &.${token.prefixCls}-fade-enter, &.${token.prefixCls}-fade-appear {
      opacity: 0;
      animation: fadeIn 0.25s ease-out forwards !important;
    }

    &.${token.prefixCls}-fade-leave {
      animation: fadeOut 0.2s ease-in forwards !important;
    }
  }

  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  @keyframes fadeOut {
    from {
      opacity: 1;
    }
    to {
      opacity: 0;
    }
  }

  @keyframes fadeSlideIn {
    from {
      opacity: 0;
      transform: translateY(-4px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @keyframes fadeSlideOut {
    from {
      opacity: 1;
      transform: translateY(0);
    }
    to {
      opacity: 0;
      transform: translateY(-4px);
    }
  }

  /* Make assistant message backgrounds transparent */
  /* Target ChatItem components with placement="left" (assistant messages) */
  [data-placement='left'] {
    background: transparent !important;

    /* Target all possible background elements within assistant messages */
    > div,
    .ant-typography,
    [class*='bubble'],
    [class*='content'],
    [class*='message'],
    [class*='chat-item'] {
      background: transparent !important;
      border: none !important;
    }
  }

  /* Alternative selector for assistant role */
  [data-role='assistant'] {
    background: transparent !important;
    border: none !important;

    > div,
    .ant-typography,
    [class*='bubble'],
    [class*='content'],
    [class*='message'],
    [class*='chat-item'] {
      background: transparent !important;
    }
  }

  /* More specific targeting for bubble variant */
  [data-variant='bubble'][data-placement='left'],
  [data-variant='bubble'][data-role='assistant'] {
    background: transparent !important;

    /* Target the bubble content specifically */
    [class*='bubble'],
    [class*='content'],
    .ant-typography {
      background: transparent !important;
      border: none !important;
    }
  }

  /* Additional broad selectors to ensure coverage */
  /* Target any element with assistant role or left placement */
  *[data-role='assistant'] > div,
  *[data-placement='left'] {
  }

  /* Target specific UI library classes that might have backgrounds */
  .lobe-chat-item,
  .lobe-chat-bubble,
  .lobe-markdown,
  [class*='lobe-'] {
    &[data-role='assistant'],
    &[data-placement='left'] {
      background: transparent !important;
      border: none !important;
    }
  }
  .chat-item-user > div > [data-layout='vertical'] > div > div {
    background: linear-gradient(
      90deg,
      var(--input-primary-background) 0%,
      var(--input-primary-background-2) 140.38%
    ) !important;
    border: none !important;
    color: var(--input-primary-foreground) !important;
    border-radius: 12px 12px 0 12px !important;
  }
`;

export default antdOverrideStyles;
